import React from 'react'
import { useIntl } from 'react-intl'
import PropTypes from 'prop-types'
import Image from 'next/image'

import { Link, Text } from '@/components/common'
import FeaturesFooter from '@/components/sections/FeaturesFooter'
import { Column, Layout, Row, Section } from '@/components/layout'
import { URLS } from '@/constants'
import FeaturePageHeader from '@/components/sections/FeaturePageHeader'
import compatibleScannersHeroImg from '@/assets/compatible-scanners/compatible-scanners-hero.png'
import scansnapImg from '@/assets/compatible-scanners/scansnap.png'
import ravenImg from '@/assets/compatible-scanners/raven.png'
import ricohImg from '@/assets/compatible-scanners/ricoh.png'
import panasonicImg from '@/assets/compatible-scanners/panasonic.png'
import brotherImg from '@/assets/compatible-scanners/brother.png'
import canonImg from '@/assets/compatible-scanners/canon.png'
import kodakImg from '@/assets/compatible-scanners/kodak.png'
import ambirImg from '@/assets/compatible-scanners/ambir.png'

import styles from './receipt-document-scanners.module.scss'

const imgSize = { width: 288, height: 118 }

const scanners = [
  { img: scansnapImg, name: 'scansnap', to: 'https://www.pfu-us.ricoh.com/scanners?family=scansnap-series', newTab: true },
  { img: ricohImg, name: 'ricoh', to: 'https://www.pfu-us.ricoh.com/scanners', newTab: true },
  { img: ambirImg, name: 'ambir' },
  { img: brotherImg, name: 'brother' },
  { img: canonImg, name: 'canon' },
  { img: kodakImg, name: 'kodak' },
  { img: ravenImg, name: 'raven' },
  { img: panasonicImg, name: 'panasonic' },
]

const ScannerCard = ({ name, to, img }) => {
  const renderImage = () => (
    <Image
      alt={name}
      src={img}
      {...imgSize}
    />
  )

  return (
    <div className={styles.scannerCard}>
      {to ? (
        <Link external to={to}>
          {renderImage()}
        </Link>)
        : renderImage()}
    </div>
  )
}

ScannerCard.propTypes = {
  name: PropTypes.string.isRequired,
  to: PropTypes.string,
}

const pageId = 'receiptDocumentScanners'

export default function CompatibleScanners() {
  const { formatMessage } = useIntl()
  const getPageMessage = (id) => formatMessage({ id: `pages.${pageId}.${id}` })

  return (
    <Layout.Content>
      <FeaturePageHeader
        ctaProps={{
          to: URLS.certifiedThirdPartyScanners,
          external: true,
          iconProps: { name: 'chevron-right', position: 'right' },
          children: getPageMessage('main.viewScanners'),
        }}
        description={getPageMessage('main.description')}
        heroProps={{
          src: compatibleScannersHeroImg,
          alt: 'compatible-scanners-hero',
          style: { height: 'auto' },
        }}
        subtitle={getPageMessage('main.subtitle')}
        withPricingCta={false}
      />
      <Section>
        <Row>
          <Column alignCenter gap={16} textCenter>
            <Text.H2>Certified Hardware Partners</Text.H2>
            <Text.P className="max-w-700">Neat works with any TWAIN compliant scanner, which includes most scanners on the market today. Additionally, Neat works with most major manufacturers to ensure their devices work seamlessly with Neat’s software. Connecting these devices is covered as part of our standard support plans.</Text.P>
            <div className={styles.scannerCards}>
              {scanners.map(scanner => <ScannerCard key={scanner.name} {...scanner} />)}
            </div>
          </Column>
        </Row>
      </Section>
      <FeaturesFooter />
    </Layout.Content>
  )
}

CompatibleScanners.layoutProps = {
  pageId,
}
